import React from 'react';
import moment from 'moment';
import CircularIndicator from '../common/indicators/circularIndicator';

const colorCircular = risk => {
  const obj = {
    bad: [],
    medium: [],
    good: []
  };
  if(risk==null) {
    obj.good.push(-1, -1);
    obj.medium.push(-1, -1);
    obj.bad.push(-1, -1);    
  }
  else if (risk.toUpperCase() === 'GOOD') {
    obj.good.push(0, 100);
    obj.medium.push(-1, -1);
    obj.bad.push(-1, -1);
  } else if (risk.toUpperCase() === 'MEDIUM') {
    obj.good.push(-1, -1);
    obj.medium.push(0, 100);
    obj.bad.push(-1, -1);
  } else if (risk.toUpperCase() === 'BAD') {
    obj.good.push(-1, -1);
    obj.medium.push(-1, -1);
    obj.bad.push(0, 101);
  }

  return obj;
};

const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'BAD' || severety.toUpperCase() === 'WORSE') {
    return 'red';
  } else if (severety.toUpperCase() === 'GOOD' || severety.toUpperCase() === 'BETTER') {
    return 'green';
  } else if (severety.toUpperCase() === 'SAME') {
    return 'gris';
  }
  return 'yellow';
};

const textTrend = (trend, val) => {
  let text;
  if (trend.toUpperCase() === 'BETTER') {
    text = `${val}% mejor respecto al período anterior`;
  } else if (trend.toUpperCase() === 'WORSE') {
    text = `${val}% peor respecto al período anterior`;
  } else if (trend.toUpperCase() === 'SAME') {
    text = `No hay cambios con respecto al período anterior`;
  }
  return text;
};

const arrow = type => {
  let text;
  if (type.toUpperCase() === 'INCREASE') {
    text = <i className="fas fa-arrow-up" />;
  } else if (type.toUpperCase() === 'DECREASE') {
    text = <i className="fas fa-arrow-down" />;
  } else if (type.toUpperCase() === 'NONE') {
    text = <i className="fas fa-minus" />;
  }
  return text;
};

const renderCircularModalIndicators = data => {
  if(data.difference.trend!=null && data.difference.type!=null) {
    return (
      <div className={colorSeverityItem(data.difference.trend) + " difference-indicators"}>
        <div className="tour-aux-light-area difference-indicators-tour"/>
        {arrow(data.difference.type)} <h3 className={colorSeverityItem(data.difference.trend)}>{data.difference.value}%</h3>
        <div className="modal-indicators-info">
          <a className={colorSeverityItem(data.difference.trend)}>
            <i className="fas fa-question-circle" />
            <div>
              <h6 className={colorSeverityItem(data.difference.trend)}>
                {textTrend(data.difference.trend, data.difference.value)}
              </h6>
              <p>
                Período anterior ({moment(data.previousValue.start).format('DD-MM')} al{' '}
                {moment(data.previousValue.end).format('DD-MM')}){' '}
                <span className={colorSeverityItem(data.previousValue.type)}>
                  {data.previousValue.value}%
                </span>
              </p>
              <p>
                Período actual ({moment(data.value.start).format('DD-MM')} al{' '}
                {moment(data.value.end).format('DD-MM')}){' '}
                <span className={colorSeverityItem(data.value.type)}>{data.value.value}%</span>
              </p>
            </div>
          </a>
        </div>
      </div>
    );
  }
  return (<div className="difference-indicators"></div>);
};

const Circular = props => {
  return (
    <div className="container-circular">
      <div className="tour-aux-light-area indicator-tour"/>
      {renderCircularModalIndicators(props.data)}
      <div className="modal-indicators-info">
        <div className="tour-aux-light-area help-buttons-tour"/>
        <a className="green">
          <i className="fas fa-question-circle" />
          <div>            
            <p>{props.language.summary.ffdSleep[props.reportType].indicatorHelp1}</p>
            <p>{props.language.summary.ffdSleep[props.reportType].indicatorHelp2}</p>
            <p>
              <span className="green">
              {props.language.summary.ffdSleep[props.reportType].labelRate + " " + props.language.summary.graphTooltip.GOOD + ": "}
              </span> 
              {props.language.summary.ffdSleep[props.reportType].between + " " + props.ffd.graphRange.good[0] + "% a " + props.ffd.graphRange.good[1] +"%"}
            </p>
            <p>
              <span className="yellow">
              {props.language.summary.ffdSleep[props.reportType].labelRate + " " + props.language.summary.graphTooltip.MEDIUM + ": "}
              </span> 
              {props.language.summary.ffdSleep[props.reportType].between + " " + (props.ffd.graphRange.medium[0]+1) + "% a " + props.ffd.graphRange.medium[1] +"%"}
            </p>
            <p>
              <span className="red">
              {props.language.summary.ffdSleep[props.reportType].labelRate + " " + props.language.summary.graphTooltip.BAD + ": "}
              </span> 
              {props.language.summary.ffdSleep[props.reportType].between + " " + (props.ffd.graphRange.bad[0]+1) + "% a 100%"}
            </p>
            {props.data.value.type!=null && (
              <p>{props.language.summary.ffdSleep[props.reportType].indicatorHelp3 + " "}
              <span className={colorSeverityItem(props.data.value.type)}>{props.language.summary.graphTooltip[props.data.value.type.toUpperCase()]}</span></p>
            )}
          </div>
        </a>
      </div>
      <div className="circular-graph-line">
        <div className="box-circular">
          <CircularIndicator
            size={130}
            max={100}
            value={props.data.value.value}
            forceValue={100}
            fill
            id={'circle1'}
            valueFormat={{ type: 'NUMBER', format: '.0f', sufix: '%' }}
            graphColorRange={colorCircular(props.data.value.type)}
          />
        </div>
      </div>
      <h3>{props.language.summary.ffdSleep[props.reportType].indicatorPeriod}</h3>
    </div>
  );
};
export default Circular;



// WEBPACK FOOTER //
// ./source/client/components/summary_ffd_sleep/circular.jsx